/* eslint-disable consistent-return */
export default function negativeHandler(event) {
  if (event.key === '-' || event.key === '.' || event.key === '+' || event.key === 'e' || event.key === 'E') {
    event.preventDefault();

    return false;
  }
}
